import { createContext, useContext } from 'react';

/**
 * Context for marking the current render tree as an embedded Confluence page.
 *
 * When `isEmbedded` is `true`, the UFO segment interop components
 * (`PageSegmentLoadStart`, `PageSegmentLoadEnd`) prefix segment keys with
 * `'embedded-'` so they are reported distinctly from regular page segments.
 * For example, a segment with key `'content-renderer'` will be reported as
 * `'embedded-content-renderer'`.
 *
 * When no provider is present (or `isEmbedded` is `false`), segment keys are
 * used as-is — preserving backward compatibility for non-embedded pages.
 */
export const EmbeddedConfluenceTrackingContext = createContext<boolean>(false);

export const useIsEmbeddedTracking = (): boolean => useContext(EmbeddedConfluenceTrackingContext);
